import {sendRequest} from "./APIClient";

export async function getCurrentUser(): Promise<User> {
  const response = await sendRequest<undefined, User>('/users/currentUser', 'get', undefined);
  return response.data;
}